/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NewsItem } from '../models/NewsItem';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NewsService {
    /**
     * @returns NewsItem OK
     * @throws ApiError
     */
    public static getApiV1News({
        externalId,
    }: {
        externalId?: Array<number | string>,
    }): CancelablePromise<Array<NewsItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/News',
            query: {
                'externalId': externalId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
}
